import { render } from "./InputContainer.vue?vue&type=template&id=b56069f8"
import script from "./InputContainer.vue?vue&type=script&lang=js"
export * from "./InputContainer.vue?vue&type=script&lang=js"

import "./InputContainer.vue?vue&type=style&index=0&id=b56069f8&lang=scss"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__